/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zusatzvereinbarungerhalten1Inputs */

const de__field_zusatzvereinbarungerhalten1 = /** @type {(inputs: _Field_Zusatzvereinbarungerhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzvereinbarung erhalten`)
};

/**

* @param {_Field_Zusatzvereinbarungerhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zusatzvereinbarungerhalten1 = /** @type {((inputs?: _Field_Zusatzvereinbarungerhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zusatzvereinbarungerhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zusatzvereinbarungerhalten1(inputs)
});
export { _field_zusatzvereinbarungerhalten1 as "_field_zusatzvereinbarungErhalten" }